export const DISCOUNT_ERRORS = {
  MINIMUM_BASKET: 'Add more items to apply this discount code.',
  INVALID_CODE: 'Oops! This code is not valid.',
  EXPIRED_CODE: 'Oops! This code is not valid.',
  NOT_APPLICABLE: 'This discount is not applicable for the selected item(s).',
  DEACTIVATED: 'Oops! This discount code is no longer valid.',
  UNABLE_TO_APPLY: 'Unable to apply discount. Please try again.',
};

/** Commercetools cart discount target types used for product-specific discount detection. */
export const DISCOUNT_TARGET_TYPES = {
  LINE_ITEMS: 'lineItems',
  MULTI_BUY_LINE_ITEMS: 'multiBuyLineItems',
} as const;


export enum DiscountErrorCode {
  INVALID_CODE = 'INVALID_CODE',
  EXPIRED_CODE = 'EXPIRED_CODE',
  MIN_BASKET_NOT_MET = 'MIN_BASKET_NOT_MET',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  DEACTIVATED = 'DEACTIVATED',
  REMOVE_FAILED = 'REMOVE_FAILED',
  UNABLE_TO_APPLY = 'UNABLE_TO_APPLY',
}

export const mapErrorCodeToMessage = (errorCode: DiscountErrorCode | null): string | null => {
  if (!errorCode) return null;

  switch (errorCode) {
    case DiscountErrorCode.INVALID_CODE:
      return DISCOUNT_ERRORS.INVALID_CODE;
    case DiscountErrorCode.EXPIRED_CODE:
      return DISCOUNT_ERRORS.EXPIRED_CODE;
    case DiscountErrorCode.MIN_BASKET_NOT_MET:
      return DISCOUNT_ERRORS.MINIMUM_BASKET;
    case DiscountErrorCode.NOT_APPLICABLE:
      return DISCOUNT_ERRORS.NOT_APPLICABLE;
    case DiscountErrorCode.DEACTIVATED:
      return DISCOUNT_ERRORS.DEACTIVATED;
    case DiscountErrorCode.REMOVE_FAILED:
      return 'Failed to remove discount code';
    case DiscountErrorCode.UNABLE_TO_APPLY:
      return DISCOUNT_ERRORS.UNABLE_TO_APPLY;
    default:
      return DISCOUNT_ERRORS.INVALID_CODE;
  }
};
